import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';
import { Button } from '@ps-design-system/components/Button';

import PauseReasons from './PauseReasons';
import PauseToggle from './PauseToggle';

const PauseListing = ({ onNextStep, applyToAllListingsToggle, setApplyToAllListingsToggle }) => {
  return (
    <div className="pause-listing-container pause-listing-brand-colors">
      <Text typeface="headline-2-m">
        <FormattedMessage id="pause.modal.title" defaultMessage="Pause listing"/>
      </Text>
      <Text typeface="body-2">
        <FormattedMessage id="pause.modal.description" defaultMessage="Temporarily prevent inquiries and new bookings. Your listing will not appear in search results but may still be accessed. Recommended for undergoing renovations or if you’re taking a long vacation."/>
      </Text>
      <PauseReasons/>
      <PauseToggle toggle={applyToAllListingsToggle} onToggle={setApplyToAllListingsToggle}/>
      <Button fullWidth onClick={onNextStep}>
        <FormattedMessage id="pause.modal.button" defaultMessage="Continue to pause listing"/>
      </Button>
    </div>
  );
};

PauseListing.propTypes = {
  onNextStep: PropTypes.func,
  applyToAllListingsToggle: PropTypes.bool,
  setApplyToAllListingsToggle: PropTypes.func
};

PauseListing.defaultProps = {
  onNextStep: () => {},
  applyToAllListingsToggle: false,
  setApplyToAllListingsToggle: () => {}
};

export default PauseListing;
